/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const BaselineInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 300}}>
          <h3>班別工時基準</h3>
          <P>為該班別人員正常工時、折算月休代金標準工時</P>
        </section>
      }
    />
  );
};

export default BaselineInfo;
